import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.AddUsersList', {
    inputPlaceholder: 'Enter or copy email(s) here...',
    addButtonText: 'Add',
    invalidEmailsDescription: 'The following emails are invalid and can not be added:',
    invalidEmailsText: '...and {count} more.',
    emailsBelongsToATeamMember: 'The following emails already exist in the Organisation:',
});
